import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import DetailsSection from "./components/DetailsSection";
import Loading from "../admin/childComponents/appComponents/Loading";

function Read() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const { reads } = useParams();

  const [loading, setLoading] = useState(true);

  const [readData, setReadData] = useState({});

  useEffect(() => {
    fetchReadData();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [reads]);

  const fetchReadData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${BASE_URL}read-data?id=${reads}`);

      setReadData(response?.data?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading message01="Loading..." />;
  }

  return (
    <>
      {readData?.readSection?.data?.length > 0 && (
        <DetailsSection
          datacontent={readData?.readSection?.data || []}
          downloadSection={readData?.downloadSection?.data || []}
          sideNewSection={readData?.sideNewSection?.data || []}
          advertSection={readData?.advertSection?.data || []}
          initialPagination={readData?.readSection?.pagination || {}}
          initialPaginationDownload={readData?.downloadSection?.pagination || {}}
          datacontentDataSearch={readData?.readSection?.dataSearch || {}}
        />
      )}
    </>
  );
}

export default Read;
